import { render } from "./TheAdminCalendarEventCreate.vue?vue&type=template&id=390b2682&ts=true"
import script from "./TheAdminCalendarEventCreate.vue?vue&type=script&lang=ts"
export * from "./TheAdminCalendarEventCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__